/** The floating control chip over the viewport: dark glass with a hairline.
 *  Shared by the corner controls and the review scan bar. */
export const CTRL =
  'pointer-events-auto inline-flex items-center justify-center rounded-md border border-white/20 bg-black/60 text-white transition-colors hover:bg-black/80 disabled:pointer-events-none disabled:opacity-40';
